export const RETIRED_ASSET_KINDS: readonly string[] = ["motion_visual"];

export const RETIRED_ASSET_REASON =
  "Retired kind. Hidden from every fan facing list, email and count. The files stay in Cloudinary and in the database.";

export const ASSET_PAGE_CAP = 200;

export interface CountableAsset {
  kind: string;
  isPublished: boolean;
}

export function isRetiredAssetKind(kind: string | undefined | null): boolean {
  return typeof kind === "string" && RETIRED_ASSET_KINDS.includes(kind);
}

export function isFanVisibleAsset(asset: CountableAsset): boolean {
  return asset.isPublished === true && !isRetiredAssetKind(asset.kind);
}

export function fanVisibleAssets<T extends CountableAsset>(assets: readonly T[]): T[] {
  return assets.filter((asset) => isFanVisibleAsset(asset));
}

export function countFanVisibleAssets(assets: readonly CountableAsset[]): number {
  let count = 0;
  for (const asset of assets) {
    if (isFanVisibleAsset(asset)) count += 1;
  }
  return count;
}

export interface AssetTally {
  total: number;
  published: number;
  fanVisible: number;
  retired: number;
  downloads: number;
}

export function emptyAssetTally(): AssetTally {
  return { total: 0, published: 0, fanVisible: 0, retired: 0, downloads: 0 };
}

export function addToAssetTally(tally: AssetTally, asset: CountableAsset & { downloadCount?: number }): AssetTally {
  tally.total += 1;
  if (asset.isPublished) tally.published += 1;
  if (isRetiredAssetKind(asset.kind)) tally.retired += 1;
  if (isFanVisibleAsset(asset)) tally.fanVisible += 1;
  tally.downloads += asset.downloadCount ?? 0;
  return tally;
}

export function tallyAssets(assets: readonly (CountableAsset & { downloadCount?: number })[]): AssetTally {
  const tally = emptyAssetTally();
  for (const asset of assets) addToAssetTally(tally, asset);
  return tally;
}

export function fileCountLabel(count: number): string {
  return `${count} ${count === 1 ? "file" : "files"}`;
}
